import * as Yup from "yup";
import type { ClassicInputGroup, DropdownInputGroup, InputGroup } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";
import { getOptions } from "@features/dropdownOptions/fetchOptions";
import { registerInitialValues } from "@features/auth/authTypes";

// Re-exported from @features/auth/authTypes — canonical location.
// See docs/adr/0001-feature-vs-page-layering.md
export type { RegisterFormType } from "@features/auth/authTypes";

/**
 * @deprecated Import `registerInitialValues` from `@features/auth/authTypes`.
 * Kept here as `initialValues` for existing page/form consumers.
 */
export const initialValues = registerInitialValues;

export const validationSchema = Yup.object().shape({
	password: Yup.string()
		.min(8, "validations.min_8_characters")
		.required("validations.field_required"),
	first_name: Yup.string(),
	last_name: Yup.string(),
	email: Yup.string().email("Invalid email").required("validations.field_required"),
	isAgreeToEmailUpdates: Yup.boolean(),
	isAgreeToGDPR: Yup.boolean().oneOf([true], 'validations.gdpr_consent_required'),
	isAgreeToTerms: Yup.boolean().oneOf([true], 'validations.terms_consent_required'),
	})

const countries = () => getOptions("country");

export const getRegisterInputGroups: () => InputGroup[] = () => {
	const rows: ClassicInputGroup[] = [
		{
			type: FieldType.CLASSIC,
			inputName: "email",
			inputType: "text",
			label: "user.email_required",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "password",
			inputType: "password",
			label: "user.password_required",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "first_name",
			inputType: "text",
			label: "user.first_name",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "last_name",
			inputType: "text",
			label: "user.last_name",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "organization",
			inputType: "text",
			label: "user.organization",
		},
	];

	const country: DropdownInputGroup = {
		type: FieldType.SELECT,
		inputName: "country",
		label: "user.user_country",
		dropdownOptions: countries,
	};

	return [...rows, country];
};
